import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { searchInfoByParamFailed, searchInfoByParamSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2, LOADING_DELAY } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* searchInfoByParam(action) {
  try {
    const { filter, type } = action.payload;
    const pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    let url = `${BACKEND_URL_V2}/dict/applicants/search`;
    if (['vehicle_lpn', 'vehicle_vin'].includes(type)) {
      url = `${BACKEND_URL_V2}/dict/vehicles/search`;
      // pool.include = 'registryVehicle';
    }
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(searchInfoByParamSuccessful(data?.data));
      yield call(resolveActionPromise(action, data?.data));
    } else {
      yield put(searchInfoByParamFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(searchInfoByParamFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
